export enum EAccessGroupDynFeatureTypes {
  DAY = 'DAY',
  EXPO = 'EXPO',
  ZONE = 'ZONE',
  STAGE = 'STAGE',
  ACCESS_GROUP = 'ACCESS_GROUP',
}

export enum EGrantStatus {
  GRANT = 'GRANT',
  NO_GRANT = 'NO_GRANT',
  REVOKED = 'REVOKED',
}
